import store from 'state'

/**
 * Get the local currency exchange rate based on USD
 * @param localCurrency local currency
 * @returns local currency exchange rate based on USD
 */
export const getLocalCurrencyExRate = (localCurrency: string): number => {
  const fxRates = store.getState().info.fxRateMap
  const currencyKey = localCurrency?.toUpperCase()
  if (currencyKey === 'USD') return 1
  return fxRates[currencyKey] ?? 1
}
